import React, { FC } from 'react';
import { ContainerBase } from 'src/components/widgets/layouts';
import { SkeletonBlock, SkeletonStack } from 'src/components/widgets/skeleton';
import styled from 'styled-components';

const Container = styled(ContainerBase)`
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    /* Match the loaded onboarding page: cover at least the full fullscreen viewport. */
    flex: 1;
    min-height: 100vh;
    padding: 72px 20px 80px;
    box-sizing: border-box;
    background:
        radial-gradient(circle at 12% 14%, rgba(240, 128, 53, 0.1), transparent 50%),
        radial-gradient(circle at 88% 12%, rgba(152, 195, 38, 0.09), transparent 48%),
        radial-gradient(circle at 78% 86%, rgba(230, 23, 128, 0.07), transparent 50%),
        radial-gradient(circle at 18% 92%, rgba(240, 128, 53, 0.05), transparent 46%), #fcfcfb;
`;

const Brand = styled.div`
    position: absolute;
    top: 28px;
    left: 32px;
    display: flex;
`;

const Content = styled.div`
    width: 100%;
    max-width: 640px;
`;

// One row per ready-made problem, plus the 'None of the above' row that closes the list.
const OPTION_ROWS = 7;

export const OnboardingPageSkeleton: FC = () => (
    <Container>
        <Brand>
            <SkeletonBlock $height='20px' $width='84px' />
        </Brand>

        <Content>
            <SkeletonStack $gap='24px'>
                <SkeletonStack $gap='8px' $align='center' $width='100%'>
                    <SkeletonBlock $height='38px' $width='70%' />
                    <SkeletonBlock $height='20px' $width='50%' />
                </SkeletonStack>

                <SkeletonStack $gap='8px'>
                    {Array.from({ length: OPTION_ROWS }, (_, index) => (
                        <SkeletonBlock key={index} $height='48px' $radius='8px' />
                    ))}
                </SkeletonStack>

                <SkeletonBlock $height='44px' $width='180px' $margin='0 auto' />
            </SkeletonStack>
        </Content>
    </Container>
);
